import { type BuildingType } from '@aikoa/common'
import { type Language, type TFunction } from '@aikoa/i18n/react'
import { getBuildingTypeLabel } from '~/lib/assets'

export function mapBuildingTypeLabel(type: BuildingType, t: TFunction<'property'>): string {
  return getBuildingTypeLabel({ buildingType: type, t })
}

export function formatRoomsRange(min?: number, max?: number, t?: TFunction<'interest'>) {
  const roomsUnit = t ? t(($) => $.details.roomsUnit) : ''

  if (typeof min === 'number' && typeof max === 'number') {
    return `${min}–${max} ${roomsUnit}`
  }

  if (typeof min === 'number') {
    return `${min}+ ${roomsUnit}`
  }

  if (typeof max === 'number') {
    return `≤ ${max} ${roomsUnit}`
  }

  return ''
}

export function formatRange(min?: number | string, max?: number | string, unit?: string) {
  const unitValue = unit ? ` ${unit}` : ''

  if (
    min !== undefined &&
    min !== null &&
    min !== '' &&
    max !== undefined &&
    max !== null &&
    max !== ''
  ) {
    return `${min}–${max}${unitValue}`
  }

  if (min !== undefined && min !== null && min !== '') {
    return `${min}+${unitValue}`
  }

  if (max !== undefined && max !== null && max !== '') {
    return `≤ ${max}${unitValue}`
  }

  return ''
}

export function formatPrice(
  language: Language,
  t: TFunction<'interest'>,
  min?: number,
  max?: number
) {
  const priceMinLabel = t ? t(($) => $.details.priceMin) : ''
  const priceMaxLabel = t ? t(($) => $.details.priceMax) : ''

  if (min && max) {
    return `${formatPriceValue(min, language)}–${formatPriceValue(max, language)}`
  }

  if (min) {
    return `${priceMinLabel} ${formatPriceValue(min, language)}`
  }

  if (max) {
    return `${priceMaxLabel} ${formatPriceValue(max, language)}`
  }

  return '???'
}

export function formatPriceValue(value: number, language: Language) {
  // TODO: Better and reusable locale mapping/setting
  const localeMap: Record<string, string> = {
    fi: 'fi-FI',
    en: 'en-US',
    es: 'es-ES',
    sv: 'sv-SE',
  }

  const locale = localeMap[language] || 'fi-FI'

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value)
}
